// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/get-company-profession-request-schema',
  type: 'object',
  required: ['eventIdentifier'],
  properties: {
    eventIdentifier: {
      type: 'string',
      format: 'uuid',
    },
    categoryIds: {
      type: 'array',
      items: {
        type: 'integer',
      },
    },
    selectedOrganisationId: {
      type: 'integer',
    },
    selectedEventId: {
      type: 'integer',
    },
    id: {
      type: 'integer',
    },
    key: {
      type: 'string',
    },
    searchCriteria: {
      type: 'string',
    },
    'paging.CurrentPage': {
      type: 'integer',
    },
    'paging.PageSize': {
      type: 'integer',
    },
    'paging.IncludeCount': {
      type: 'boolean',
    },
    'paging.NoPaging': {
      type: 'boolean',
    },
  },
} as IJSONSchema;

export default schema;
